import React from "react";
import "./BlogDashboardMenuStyle.css";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import Button from "../../../Components/Button/Button";
import refresh from "../../../assets/svg/refresh.svg";
import add from '../../../assets/img/addBlue.svg';
import openEnvelope from "../../../assets/svg/openEnvelope.svg";
const BlogDashboardMenu = ({ searchFunction,clearSearch,currentCount,
  totalCount,onClickCreateBlog,BlogsRightMenuoption}) => {
  return (
    <header>
      <div className="secondMenu flexbox">
        
          <div className="SmenuLeft">
            <SearchBar placeholder={"Search Blog..."} searchFunction={searchFunction} clearSearch={clearSearch} />
          </div>
          <div className="SmenuMid">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
          <path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
        </svg>
        <span className="countLabel">Showing</span>
        <strong className="countValue">{currentCount}</strong>
        <span className="countLabel">of</span>
        <strong className="countValue muted">{totalCount}</strong>
      </div>
          <div className="SmenuRight newButtonWrap">
          {BlogsRightMenuoption &&
            BlogsRightMenuoption.length > 0 &&
            BlogsRightMenuoption.map((Component, index) => (
            <Component key={index} />
          ))}
          {onClickCreateBlog && (
          <Button
              onClick={onClickCreateBlog}
              className={"BlueFillButton iconButton"}
              name={"Create Blog"}
            
              src={"https://cdn.mastersunion.org/assets/dinero/openEnvelope.svg"}
            />
          )}
            
          </div>
        </div>
     
    </header>
  );
};

export default BlogDashboardMenu;
